/**
 * Handlers for the feedback forms
 * @type {handler}
 */
define('components/handlers/feedback',[
    'jquery',
    '../handlers/analytics'
],function(
    jQuery,
    analytics
){

    $.extend(companyInfo.handlers,{
        /**
         * When the feedback form is submitted
         */
        'feedback-submit': function (e) {
            analytics (['forms','submit','Feedback']);
        }

    });
});

